import { render } from "./AddonIcon.vue?vue&type=template&id=d20880ee&scoped=true&ts=true"
import script from "./AddonIcon.vue?vue&type=script&lang=ts"
export * from "./AddonIcon.vue?vue&type=script&lang=ts"

import "./AddonIcon.vue?vue&type=style&index=0&id=d20880ee&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20880ee"]])

export default __exports__